import { useState } from "react";

export const useRerender = () => {
    const [, setRerender] = useState(0);

    return () => setRerender((prev) => prev + 1);
}